var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManualSafetyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H32C40.8366 0 48 7.16344 48 16V32C48 40.8366 40.8366 48 32 48H16C7.16344 48 0 40.8366 0 32V16Z",
    fill: "#FEF2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7299 30L25.7299 16C25.5555 15.6922 25.3025 15.4362 24.9969 15.2581C24.6912 15.08 24.3437 14.9861 23.9899 14.9861C23.6361 14.9861 23.2887 15.08 22.983 15.2581C22.6773 15.4362 22.4244 15.6922 22.2499 16L14.2499 30C14.0736 30.3054 13.9812 30.6519 13.9819 31.0045C13.9827 31.3571 14.0767 31.7033 14.2544 32.0078C14.432 32.3124 14.6871 32.5646 14.9936 32.7388C15.3002 32.9131 15.6473 33.0032 15.9999 33H31.9999C32.3508 32.9997 32.6955 32.907 32.9992 32.7313C33.303 32.5556 33.5551 32.3031 33.7304 31.9991C33.9057 31.6951 33.998 31.3504 33.9979 30.9995C33.9978 30.6486 33.9054 30.3039 33.7299 30Z",
    stroke: "#E7000B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21V25",
    stroke: "#E7000B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29H24.01",
    stroke: "#E7000B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManualSafetyIcon);
export default __webpack_public_path__ + "static/media/user_manual_safety_icon.113576c02e7c69be100f1111f9b1678e.svg";
export { ForwardRef as ReactComponent };